import { MissingTranslationHandler, MissingTranslationHandlerParams } from "@ngx-translate/core";
import { environment } from "../environments/environment";

export class EmptyStringMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    if (!environment.production) {
      console.log(params.key + ' no traducida ');
    }
    return '';
  }
}
